import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons"
import { useGetBodypartsQuery } from "./bodypartsApiSlice"
import { memo } from 'react'

const Bodypart = ({ bodypartId, onBodypartChange}) => {

    const { bodypart } = useGetBodypartsQuery("bodypartsList", {
        selectFromResult: ({ data }) => ({
            bodypart: data?.entities[bodypartId]
        }),
    })

    if (bodypart) {

        return (
            <tr>
                <td>
                    {bodypart.bodypart}
                </td>
                <td>
                    <span
                        className="text-secondary"
                        role="button"
                        onClick={() => onBodypartChange(bodypartId, bodypart.bodypart)}
                        data-bs-toggle="modal" data-bs-target="#modalBodypart"
                    >
                        <FontAwesomeIcon icon={faPenToSquare} />
                    </span>
                </td>
            </tr>
        )

    } else return null
}

const memoizedbodypart = memo(Bodypart)

export default memoizedbodypart